import { render, staticRenderFns } from "./SKDataTableHeader.vue?vue&type=template&id=482b3a4e&scoped=true&"
import script from "./SKDataTableHeader.vue?vue&type=script&lang=js&"
export * from "./SKDataTableHeader.vue?vue&type=script&lang=js&"
import style0 from "./SKDataTableHeader.vue?vue&type=style&index=0&id=482b3a4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482b3a4e",
  null
  
)

export default component.exports